import { getSessionAuthentication, rms2BasePath } from '../common/Api';

interface FetchOptions {
    method: string;
    headers: Record<string, string>;
    body?: string;
}

function getHeaders(): Record<string, string> {
    const auth = getSessionAuthentication();
    return {
        'Content-Type': 'application/json',
        'Authorization': auth.token,
        'x-cleverapps-tenant': auth.tenantStringIdentifier
    };
}

async function rms2Fetch<T>(path: string, options?: Partial<FetchOptions>): Promise<T | null> {
    const response = await fetch(rms2BasePath + path, {
        method: options?.method ?? 'GET',
        headers: getHeaders(),
        body: options?.body
    });
    if (!response.ok) {
        const text = await response.text();
        let message = `API error: ${response.status} ${response.statusText}`;
        try {
            const parsed = JSON.parse(text);
            if (parsed?.message) message = parsed.message;
        } catch { /* ignore */ }
        throw new Error(message);
    }
    const text = await response.text();
    return text ? JSON.parse(text) : null;
}

export interface Account {
    id: number;
    accountNumber: string;
    accountName: string;
    isRoundingAccount: boolean;
}

export async function getAccount(accountId: number): Promise<Account> {
    const result = await rms2Fetch<Account>(`accounts/${accountId}`);
    if (!result) throw new Error('Empty response for getAccount');
    return result;
}

export async function createAccount(account: Partial<Account>): Promise<Account> {
    const result = await rms2Fetch<Account>('accounts', {
        method: 'POST',
        body: JSON.stringify(account)
    });
    if (!result) throw new Error('Empty response for createAccount');
    return result;
}

export async function updateAccount(account: Account): Promise<Account> {
    const result = await rms2Fetch<Account>(`accounts`, {
        method: 'PUT',
        body: JSON.stringify(account)
    });
    if (!result) throw new Error('Empty response for updateAccount');
    return result;
}

export async function deleteAccount(accountId: number): Promise<void> {
    await rms2Fetch<void>(`accounts/${accountId}`, {
        method: 'DELETE'
    });
}
